import React from "react";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import ServiceAreaSection from "@/components/ServiceAreaSection";
import ServiceRequestForm from "@/components/ServiceRequestForm";
import TestimonialsSection from "@/components/TestimonialsSection";
import AboutSection from "@/components/AboutSection";
import Footer from "@/components/Footer";
import AdminPanel from "@/components/AdminPanel";

function LandingPage() {
  return (
    <>
      <Header />
      <HeroSection />
      <ServicesSection />
      <ServiceAreaSection />
      <TestimonialsSection />
      <ServiceRequestForm />
      <AboutSection />
      <Footer />
    </>
  );
}

function AdminRoute() {
  const navigate = useNavigate();
  return <AdminPanel onBack={() => navigate("/")} />;
}

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin" element={<AdminRoute />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
